// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For static exports with token substitution:
// - Build-time: Use #{TOKEN_*}# placeholders that get baked into the bundle
// - Release-time: Replace these tokens with actual values in the release pipeline

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("NEXT_PUBLIC_API_URL:", process.env.NEXT_PUBLIC_API_URL)
  console.log("NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT:", process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT)
  console.log("NEXT_PUBLIC_PAYROLL_INTEGRATIONS_API_URL:", process.env.NEXT_PUBLIC_PAYROLL_INTEGRATIONS_API_URL)
  console.log("NEXT_PUBLIC_BASE_PATH:", process.env.NEXT_PUBLIC_BASE_PATH)
  console.log("NEXT_PUBLIC_BUILD_ENV:", process.env.NEXT_PUBLIC_BUILD_ENV)
}

// Application environment variables
// These will be token placeholders at build time, replaced in release pipeline
export const env = {
  // Monolith API base URL
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "#{API_URL}#",

  // Admin Service API Endpoint - GlobalConfiguration document CRUD
  // (PaymentFileFormatType, PayrollProviderConfiguration, mappings)
  adminServiceApiEndpoint: process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT || "#{ADMIN_SERVICE_API_ENDPOINT}#",

  // PayrollIntegrations Function App - migrations, credentials, test-connection, dry-run, backfill
  payrollIntegrationsApiUrl: process.env.NEXT_PUBLIC_PAYROLL_INTEGRATIONS_API_URL || "#{PAYROLL_INTEGRATIONS_API_URL}#",

  // Comma-separated origins allowed to post token messages (the Phoenix host)
  allowedTokenOrigins: process.env.NEXT_PUBLIC_ALLOWED_TOKEN_ORIGINS || "#{ALLOWED_TOKEN_ORIGINS}#",

  // Build environment
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV || "#{BUILD_ENV}#",

  // Base path
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || "#{BASE_PATH}#",
}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
}
